import { render, staticRenderFns } from "./ProjectSidebar.vue?vue&type=template&id=3a4d3f27"
import script from "./ProjectSidebar.vue?vue&type=script&lang=ts"
export * from "./ProjectSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports